var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseOurSampleProject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 128,
    viewBox: "0 0 137 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "o3pjyrgqaa",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 137,
    height: 128
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 135,
    height: 127,
    rx: 4.5,
    fill: "#F9F9FB",
    stroke: "#D6DAE4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#o3pjyrgqaa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#22283C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M27.894 71.125 100.94 81.41l-10.412 73.95-73.046-10.285z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#22283C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M129.581 65 16.986 55.445 6.5 179l112.596 9.555z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 124,
    rx: 6,
    transform: "matrix(-1 0 0 1 120.54 45)",
    fill: "#fff",
    stroke: "#22283C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.54,
    cy: 54,
    r: 2,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.978,
    cy: 54,
    r: 2,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.417,
    cy: 54,
    r: 2,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.54 92.5 10.044-5.428a6 6 0 0 1 4.268-.553l7.448 1.807a6 6 0 0 0 4.656-.78l6.736-4.324a6 6 0 0 1 4.903-.716l6.382 1.84a6 6 0 0 0 4.769-.63L81.943 73.31a6 6 0 0 1 6.342.081l4.758 3.047a6 6 0 0 0 7.408-.74L112.54 64",
    stroke: "#22283C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECEEF5",
    d: "M66.54 103h5v2h-5zM78.54 103h10v2h-10zM87.54 53h7v2h-7zM93.54 103h19v2h-19zM98.787 53h13.754v2H98.787zM98.787 57h13.754v2H98.787zM66.54 110h5.412v2H66.54zM78.717 110h9.471v2h-9.471zM93.933 110h18.608v2H93.933zM66.54 117h5.412v2H66.54zM78.717 117h9.471v2h-9.471zM93.933 117h18.608v2H93.933z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.822,
    cy: 72.825,
    r: 3,
    fill: "#fff",
    stroke: "#22283C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.04 103a8.5 8.5 0 1 0 8.5 8.5h-8.5V103zM48.04 103a8.5 8.5 0 1 0 8.5 8.5h-8.5V103z",
    fill: "#ECEEF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseOurSampleProject);
export default __webpack_public_path__ + "static/media/UseOurSampleProject.d5884731f1099b580ac468c2f5104118.svg";
export { ForwardRef as ReactComponent };